import React from 'react';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(fas, fab, far);

export function getClasses(...classes) {
  return classes
    .filter((className) => className && Object.keys(className).length)
    .map((className) => (typeof className === 'string' ? [className] : className))
    .reduce((classes1, classes2) => [...classes1, ...classes2], [])
    .join(' ');
}

const Icon = ({ size, name = 'coffee', type = '', color, classes = {} }) => {
  const getPrefix = (type) => {
    switch (type) {
      case 'brand':
        return 'fab';
      case 'solid':
        return 'fas';
      default:
        return 'far'; // regular.
    }
  };

  return (
    <FontAwesomeIcon
      icon={[getPrefix(type), name]}
      style={{
        fontSize: size || 'initial',
      }}
      className={getClasses(classes)}
      color={color}
    />
  );
};

Icon.propTypes = {
  size: PropTypes.number,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['brand', 'solid', '']),
  color: PropTypes.string,
  classes: PropTypes.object,
};

export default Icon;
